<script setup>
const props = defineProps(['item']);

const type = computed(() => {
  return props.href ? 'nuxt-link' : 'button';
});
</script>

<template>
  <component :is="type" class="dropdown-item">
    {{ item.name }}
  </component>
</template>

<style lang="scss" scoped>
.dropdown-item {
  display: block !important;
  margin-bottom: 8px !important;
  font-size: 12px !important;
  line-height: 1.3 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  @include button-reset;
  @include underline-transition(1px);

  &:last-child {
    margin-bottom: 0 !important;
  }
}
</style>
